import {LEAD_TYPE_CREATED, LEAD_TYPE_FETCHED, LEAD_TYPE_SORT_ORDER_UPDATED, LEAD_TYPE_UPDATED} from "./actionType";
import {Action} from "redux-actions";
import {OnFailure, OnSuccess, OnSuccessData} from "../actionHelpers";
import {api} from "../../../api/api";
import {Dispatch} from "react-redux";
import DictionaryItem from "../../../model/dictionary/DictionaryItem";

/**
 * Lead types fetched successful action.
 * @param {Array<DictionaryItem>} leadTypes all lead types from server.
 * @return {Action<LEAD_TYPE_FETCHED>}
 */
function leadTypesFetched(leadTypes: Array<DictionaryItem>): Action<LEAD_TYPE_FETCHED> {
	return {type: LEAD_TYPE_FETCHED, payload: {leadTypes}};
}

/**
 * Lead type created successful action.
 * @return {Action<LEAD_TYPE_CREATED>}
 * @param leadType
 */
function leadTypeCreated(leadType: DictionaryItem): Action<LEAD_TYPE_CREATED> {
	return {type: LEAD_TYPE_CREATED, payload: {leadType}};
}

/**
 * Lead type updated successful action.
 * @return {Action<LEAD_TYPE_UPDATED>}
 * @param leadType
 */
function leadTypeUpdated(leadType: DictionaryItem): Action<LEAD_TYPE_UPDATED> {
	return {type: LEAD_TYPE_UPDATED, payload: {leadType}};
}

/**
 * Update lead types sort order successful action.
 * @param {Array<DictionaryItem>} leadTypes all lead types from server.
 * @return {Action<LEAD_TYPE_SORT_ORDER_UPDATED>}
 */
function leadTypesSortOrderUpdated(leadTypes: Array<DictionaryItem>): Action<LEAD_TYPE_SORT_ORDER_UPDATED> {
	return {type: LEAD_TYPE_SORT_ORDER_UPDATED, payload: {leadTypes}};
}

/**
 * Fetch lead types from server.
 * @param {OnSuccessData} onSuccess
 * @param {OnFailure} onFailure
 * @return {(dispatch: Dispatch<any>) => void}
 */
export function fetchLeadTypes(onSuccess: OnSuccessData<DictionaryItem[]>, onFailure: OnFailure) {
	return function(dispatch: Dispatch<any>) {
		api.instance.leadTypeApi.fetchLeadTypes().then(leadTypes => {
			dispatch(leadTypesFetched(leadTypes));
			onSuccess(leadTypes);
		}).catch(onFailure);
	};
}

/**
 * Create lead type.
 * @param leadType
 * @param {OnSuccessData} onSuccess
 * @param {OnFailure} onFailure
 * @return {(dispatch: Dispatch<any>) => void}
 */
export function createLeadType(leadType: DictionaryItem, onSuccess: OnSuccessData<DictionaryItem>, onFailure: OnFailure) {
	return function(dispatch: Dispatch<any>) {
		api.instance.leadTypeApi.createLeadType(leadType).then(leadType => {
			dispatch(leadTypeCreated(leadType));
			onSuccess(leadType);
		}).catch(onFailure);
	};
}

/**
 * Update lead type.
 * @param leadTypeId
 * @param leadType
 * @param {OnSuccessData} onSuccess
 * @param {OnFailure} onFailure
 * @return {(dispatch: Dispatch<any>) => void}
 */
export function updateLeadType(
	leadTypeId: string,
	leadType: DictionaryItem,
	onSuccess: OnSuccessData<DictionaryItem>,
	onFailure: OnFailure) {
	return function(dispatch: Dispatch<any>) {
		api.instance.leadTypeApi.updateLeadType(leadTypeId, leadType).then(leadType => {
			dispatch(leadTypeUpdated(leadType));
			onSuccess(leadType);
		}).catch(onFailure);
	};
}

/**
 * Update lead type sort order.
 * @param leadTypes
 * @param {OnSuccess} onSuccess
 * @param {OnFailure} onFailure
 * @return {(dispatch: Dispatch<any>) => void}
 */
export function updateLeadTypesSortOrder(leadTypes: DictionaryItem[],
	onSuccess: OnSuccess,
	onFailure: OnFailure) {
	return function(dispatch: Dispatch<any>) {
		api.instance.leadTypeApi.updateSortOrder(leadTypes).then(() => {
			dispatch(leadTypesSortOrderUpdated(leadTypes));
			dispatch(onSuccess);
		}).catch(onFailure);
	};
}
